module.exports = __webpack_public_path__ + "img/xmark-thin.470d0935.svg";